import f from "./design-system.es897.js";
function a(e) {
  var o = f(e), r = o.overflow, t = o.overflowX, l = o.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + l + t);
}
export {
  a as default
};
//# sourceMappingURL=design-system.es910.js.map
